import type { CloudConfig } from '../../../../../common/constants/filters/cloud-config/types';
import type { SelectFilterOption } from '../../../../../common/ui/filters/select-filter';
import { getProducts3PFromConfigForFilter } from '../../../../../common/utils/filters';
import { createMultiSelectFilter } from '../../../../filters/multi-select-filter';

import { i18n, pullRequestStatuses } from './messages';

const products3PFromConfig = getProducts3PFromConfigForFilter('pullRequestStatus');

const getAllPullRequestStatusOptions = (config: CloudConfig) => {
	const options = pullRequestStatuses.map((status) => ({
		value: status,
		trackingKey: status,
		queryParamValue: status,
		isDefault: false,
		label: config.intl?.formatMessage(i18n[status]) ?? '',
		product: config.product,
		isSelected: false,
		isSuggested: false,
	})) satisfies SelectFilterOption[];

	return options;
};

const fetchQueryParams = (queryParams: string[], config: CloudConfig): SelectFilterOption[] => {
	const allOptions = getAllPullRequestStatusOptions(config);
	return allOptions.filter((option) =>
		queryParams.find((queryParam) => option.value === queryParam),
	);
};

export const filter = createMultiSelectFilter({
	id: 'pullRequestStatus' as const,
	products: ['bitbucket', ...products3PFromConfig],
	alwaysVisible: false,
	universal: false,
	queryParams: {
		key: 'pullRequestStatus',
		fetcher: async (queryParams, config) => {
			return fetchQueryParams(queryParams, config);
		},
	},
	initialOptions: {
		fetcher: async (config) => {
			return getAllPullRequestStatusOptions(config);
		},
	},
});
